import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getQrMode, checkQrMode } from "../../api/qrWorkflowMode";
import useQrOverlayVisibility from "./useQrOverlayVisibility";
import "../../styles/checklists/qrWorkflowMode.scss";

const pillDetails = (mode, error) => {
  if (error) return { label: "QR FLOW UNAVAILABLE", tone: "unavailable" };
  if (!mode) return { label: "QR FLOW LOADING", tone: "loading" };
  if (mode.environment === "UAT" && mode.testMode) return { label: "QR · UAT FLOW", tone: "test" };
  return { label: "QR · PRODUCTION FLOW", tone: "production" };
};

export default function QrWorkflowModeProvider() {
  const { pathname } = useLocation();
  const normalisedPath = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  const hidden = ["/login", "/forgot-password", "/reset-password"].includes(normalisedPath);
  const [mode, setMode] = useState(null);
  const [error, setError] = useState("");
  const [overlayVisible] = useQrOverlayVisibility();
  useEffect(() => {
    if (hidden) return undefined;
    let active = true;
    let timer = null;
    const schedule = delay => { window.clearTimeout(timer); timer = window.setTimeout(refresh, delay); };
    const failed = () => {
      if (active) {
        setError("QR workflow mode unavailable. QR actions are unavailable until the server responds.");
        schedule(60000);
      }
    };
    const refresh = () => checkQrMode().then(value => {
      if (active) { setMode(value); setError(""); schedule(15000); }
    }).catch(failed);
    getQrMode().then(value => { if (active) { setMode(value); setError(""); schedule(15000); } }).catch(failed);
    const ready = event => { if (active) { setMode(event.detail); setError(""); } };
    window.addEventListener("qr-mode-ready", ready);
    window.addEventListener("focus", refresh);
    return () => {
      active = false;
      window.clearTimeout(timer);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("qr-mode-ready", ready);
    };
  }, [hidden]);

  if (hidden || mode?.environment !== "UAT" || !overlayVisible) return null;

  const details = pillDetails(mode, error);
  const publicEntry = normalisedPath === "/driver-check";
  return <div className={`qr-mode-pill qr-mode-pill-${details.tone}${publicEntry ? " public-entry" : ""}`} role="status" title={error || `Current QR workflow: ${details.label.replace("QR · ", "")}`}>
    <span className="qr-mode-pill-dot" aria-hidden="true"></span><strong>{details.label}</strong>
  </div>;
}
